<cdp-icons></cdp-icons>
<router-outlet></router-outlet>
